import instance from 'api';
import { downloadFile } from 'helper';
import { IDashboard, IDashboardRequest, IFilters, IMarks, IMarksRequest } from './interfaces';

const EXCEL_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const getFilters = (): Promise<IFilters> =>
  instance()
    .post('chronaVisit/dashboard/filters')
    .then((response) => response.data);

export const getDashboard = (request: IDashboardRequest): Promise<IDashboard> =>
  instance()
    .post('chronaVisit/dashboard', request)
    .then((response) => response.data);

export const getMarks = (request: IMarksRequest): Promise<IMarks> =>
  instance()
    .post('chronaVisit/dashboard/marks', request)
    .then((response) => response.data);

/** Ошибка выгрузки приходит blob'ом: разбираем тело, чтобы errorMessage показал текст сервера. */
const readBlobError = async (error: any) => {
  const data = error?.response?.data;
  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    try {
      error.response.data = JSON.parse(await data.text());
    } catch (e) {
      // Не JSON - останется общий текст ошибки.
      console.warn('Ответ выгрузки не JSON', e);
    }
  }
  throw error;
};

const downloadExcel = (url: string, body: object, filename: string) =>
  instance(true)
    .post(url, body, { responseType: 'blob' })
    .then((response) => downloadFile(response.data, EXCEL_MIME, filename))
    .catch(readBlobError);

/** Список домов текущего вида без страницы - то, что на экране. */
export const exportDashboard = (request: Omit<IDashboardRequest, 'page' | 'size'>) =>
  downloadExcel('chronaVisit/dashboard/excel', request, `chrona_houses_${request.from}_${request.to}.xlsx`);

/** Отметки за период под фильтрами и чипом, без страницы. */
export const exportMarks = (request: Omit<IMarksRequest, 'page' | 'size'>) =>
  downloadExcel('chronaVisit/dashboard/marks/excel', request, `chrona_marks_${request.from}_${request.to}.xlsx`);
